module.exports = __webpack_public_path__ + "static/assets/c26c369a2ca3f3a09b60e5af6c30bd15.gif";